(() => {
  if (!window.wardlyDarkLayoutBound) {
    window.wardlyDarkLayoutBound = true;
    let current;
    const restore = () => {
      if (!current) return;
      current.offerMarker.replaceWith(current.offers);
      current.ctaMarker.replaceWith(current.cta);
      current.perks.remove();
      current.offers.removeEventListener('change', current.onChange);
      current.offers.removeEventListener('click', current.onCard);
      current.cta.removeEventListener('click', current.onBuy);
      current.offers.classList.remove('wd-mobile-packs');
      current = null;
    };
    const arrange = () => {
      if (current && current.slot.isConnected && current.offers.isConnected) return;
      restore();
      const slot = document.querySelector('.wd-mobile-offers-slot');
      const offers = document.querySelector('.wo--offers.wo--dark');
      const cta = document.querySelector('.wd-hero-cta');
      if (!slot || !offers || !cta) return;
      const offerMarker = document.createComment('Wardly offers desktop position');
      const ctaMarker = document.createComment('Wardly CTA desktop position');
      offers.before(offerMarker); cta.before(ctaMarker);
      slot.append(offers);
      offers.querySelector('.wo-offers').after(cta);
      const perks = document.createElement('div');
      perks.className = 'wd-mobile-perks';
      cta.before(perks);
      offers.classList.add('wd-mobile-packs');
      const update = () => {
        const radios = [...offers.querySelectorAll('.wd-pack-radio input')];
        if (!radios.some(r => r.checked) && radios[0]) radios[0].checked = true;
        radios.forEach(r => r.closest('.wo-offer').classList.toggle('wd-selected', r.checked));
        const reassurance = offers.querySelector('.wd-purchase-assurance');
        if (reassurance) {
          const line = reassurance.cloneNode(true);
          line.removeAttribute('data-assurance-source');
          perks.replaceChildren(line);
        }
      };
      const onChange = e => { if (e.target.matches('.wd-pack-radio input')) update(); };
      const onCard = e => {
        if (e.target.closest('button,a,input,label,select')) return;
        const card = e.target.closest('.wo-offer');
        const radio = card?.querySelector('.wd-pack-radio input');
        if (radio) { radio.checked = true; update(); }
      };
      const onBuy = e => {
        const card = offers.querySelector('.wd-pack-radio input:checked')?.closest('.wo-offer');
        const form = card?.querySelector('form.wo-product-form');
        if (form) { e.preventDefault(); form.requestSubmit(form.querySelector('[name="add"]')); }
      };
      offers.addEventListener('change', onChange);
      offers.addEventListener('click', onCard);
      cta.addEventListener('click', onBuy);
      current = { slot, offers, cta, perks, offerMarker, ctaMarker, onChange, onCard, onBuy };
      update();
    };
    document.addEventListener('shopify:section:load', arrange);
    document.addEventListener('shopify:section:unload', restore);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrange, { once: true });
    else arrange();
  }
  if (!customElements.get('wardly-reading-card')) {
    customElements.define('wardly-reading-card', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.value = this.querySelector('[data-reading-value]');
        this.status = this.querySelector('[data-reading-status]');
        this.sequence = [0, 0.02, 0.01, 0.04, 0.12, 0.23, 0.18, 0.39, 0.32, 0.57, 0.79, 0.70, 1, 0.87, 0.61, 0.68, 0.40, 0.25, 0.12, 0.05, 0.02, 0];
        this.maximum = Math.min(300, Math.max(20, Number(this.dataset.maximum) || 120));
        this.interval = Math.min(2500, Math.max(500, Number(this.dataset.interval) || 1000));
        this.index = 0;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.onClick = () => { this.paused = !this.paused; this.update(); };
        this.onVisibility = () => this.update();
        this.onMotion = e => { if (e.matches) { this.paused = true; this.update(); } };
        this.button.addEventListener('click', this.onClick);
        this.motion.addEventListener('change', this.onMotion);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.renderReading();
        this.update();
      }
      renderReading() {
        const level = this.sequence[this.index];
        const state = level <= 0.04 ? 'clear' : level < 0.5 ? 'rising' : 'high';
        this.value.textContent = String(Math.round(level * this.maximum));
        this.dataset.state = state;
        if (this.status) this.status.textContent = this.dataset[state] || state;
      }
      update() {
        clearInterval(this.timer);
        this.classList.toggle('is-paused', this.paused);
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
        if (!this.paused && !document.hidden) this.timer = setInterval(() => {
          this.index = (this.index + 1) % this.sequence.length;
          this.renderReading();
        }, this.interval);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.button?.removeEventListener('click', this.onClick);
        this.motion?.removeEventListener('change', this.onMotion);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }
  if (!customElements.get('wardly-benefit-scroll')) {
    customElements.define('wardly-benefit-scroll', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onClick = () => { this.paused = !this.paused; this.update(); };
        this.onSelect = () => { this.paused = true; this.update(); };
        this.button.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onSelect);
        this.update();
      }
      update() {
        this.classList.toggle('is-paused', this.paused);
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onSelect);
      }
    });
  }
})();

